
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.5 3.75h8.75V5H7.5V3.75zm0 3.75h6.25v1.25H7.5V7.5zm0 3.75h8.75v1.25H7.5v-1.25zm0 3.75h6.25v1.25H7.5V15zM3.75 2.5H5v15H3.75v-15z","fill":"#585858"}})])
          )
        }
      }
    